<template>
  <tbody :class="[showDetail ? 'isActive' : '', 'tbody']" v-if="bu">
    <tr>
      <td @click="showDetail = !showDetail">
        <v-icon
          v-if="bu.isDefault"
          color="light-blue"
          :title="$i18n.t('Default Entity')"
          >mdi-police-badge</v-icon
        >
        {{ bu.name }}
      </td>
      <td @click="showDetail = !showDetail">{{ bu.gstin }}</td>
      <td @click="showDetail = !showDetail">
        <v-icon v-if="bu.rcmApplicable">mdi-check</v-icon>
        <v-icon v-if="!bu.rcmApplicable">mdi-close</v-icon>
      </td>
      <td @click="showDetail = !showDetail">
        <v-icon v-if="bu.underSEZ">mdi-check</v-icon>
        <v-icon v-if="!bu.underSEZ">mdi-close</v-icon>
      </td>
      <td @click="showDetail = !showDetail">
        {{ bu.invoicePrefix ? "Prefix : " + bu.invoicePrefix : "" }}
        {{ bu.invoicePrefix && bu.invoicePrefixSEZ ? "|" : "" }}
        {{ bu.invoicePrefixSEZ ? "SEZ Prefix :" + bu.invoicePrefixSEZ : "" }}
      </td>
      <td @click="showDetail = !showDetail">
        <v-icon v-if="bu.resetInvoiceNoInApril">mdi-check</v-icon>
        <v-icon v-if="!bu.resetInvoiceNoInApril">mdi-close</v-icon>
      </td>
      <td @click="showDetail = !showDetail">{{ bu.address.addressLine }}</td>
      <td @click="showDetail = !showDetail">
        <span v-if="bu.contactPeople && bu.contactPeople.length > 0">
          {{ bu.contactPeople[0].name }}
          <br />
          <!-- {{bu.contactPeople[0].countryCode != undefine && bu.contactPeople[0].phone ? bu.contactPeople[0].countryCode + " " + bu.contactPeople[0].phone :""}}
                <br />-->
          {{ bu.contactPeople[0].designation }}
          <br />
          {{ bu.contactPeople[0].email }}
        </span>
      </td>
      <td @click="showDetail = !showDetail">
        <strong v-if="bu.rcmApplicable">
          {{ $i18n.t("RCM Applicable") }}
          <br />
        </strong>
        <strong v-if="bu.underSEZ">
          {{ $i18n.t("Under SEZ") }}
          <br />
        </strong>
        <strong v-if="bu.invoicePrefix">
          {{ $i18n.t("Inv. Prefix:") + bu.invoicePrefix }}
          <br />
        </strong>
        <strong v-if="bu.invoicePrefixSEZ">
          {{ $i18n.t("Inv. Prefix SEZ:") + bu.invoicePrefixSEZ }}
          <br />
        </strong>
      </td>
      <td @click="showDetail = !showDetail">
        <z-confirm-button
          class="float-right"
          color="red lighten-1"
          small
          fab
          text
          v-if="!bu.isDefault"
          dark
          :message="$i18n.t('Do you want to delete this bu ?')"
          @click="deletebu(bu)"
        >
          <v-icon>mdi-trash-can-outline</v-icon>
        </z-confirm-button>
        <z-confirm-button
          class="float-right"
          color="info"
          small
          fab
          v-if="!bu.isDefault"
          text
          dark
          :message="
            $i18n.t('Do you want to make this Entity as Primary Entity?')
          "
          @click="makePrimary(bu)"
        >
          <v-icon>mdi-police-badge</v-icon>
        </z-confirm-button>
        <v-tooltip top v-if="!singlePage">
          <template v-slot:activator="{ on }">
            <v-btn
              class="float-right"
              color="primary"
              small
              fab
              text
              dark
              :to="'/entity/' + bu._id"
              v-on="on"
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </template>
          <span>Edit</span>
        </v-tooltip>
        <v-tooltip top v-if="singlePage">
          <template v-slot:activator="{ on }">
            <v-btn
              class="float-right"
              color="primary"
              small
              fab
              text
              dark
              @click="entityEdit(bu._id)"
              v-on="on"
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </template>
          <span>Edit</span>
        </v-tooltip>
        <v-tooltip top v-if="showSelectBtn">
          <template v-slot:activator="{ on }">
            <v-btn
              class="float-right"
              color="success"
              small
              fab
              text
              dark
              @click="select"
              v-on="on"
            >
              <v-icon>mdi-check</v-icon>
            </v-btn>
          </template>
          <span>Select</span>
        </v-tooltip>
        <v-btn
          class="float-right"
          rounded
          text
          fab
          x-small
          color="grey"
          :to="'/entity/' + bu._id + '/clone'"
        >
          <v-icon>mdi-content-copy</v-icon>
        </v-btn>
      </td>
    </tr>

    <tr v-if="showDetail" style="background-color: #e0f2f1">
      <td colspan="14" style="text-align: -webkit-center">
        <entity-edit :value="bu" :entity_id="bu._id" :singlePage="singlePage" />
      </td>
    </tr>
  </tbody>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
import common from "@/store/common/module/common";
import { doGet, doPost } from "@/store/common/module/apis";
import EntityEdit from "@/views/entity/EntityEdit";

@Component({
  name: "EntityRow",
  props: {
    value: {
      default: null,
    },
    selected: {
      default: false,
    },
    singlePage: {
      default: false,
    },
    showSelectBtn: {
      default: false,
    },
  },
  components: {
    EntityEdit,
  },
})
export default class EntityRow extends Vue {
  bu = null;
  attrs = null;
  finalFilters = {};
  payload = {};
  showDetail = false;

  get loading() {
    return common.loading;
  }

  closeDialog(reload) {
    this.showCreateInvoice = false;
    if (reload) this.$emit("reload", true);
    this.showInvoiceDoanload = false;
    this.payload = {};
    this.invForMail = null;
    this.isMail = false;
  }

  async cancelTrip() {
    const data = { trip_id: this.bu._id };
    try {
      common.setLoading(true);
      await doPost("/api/trip/mark/cancelled", data);
      this.$emit("reload", true);
      common.setLoading(false);
      this.showPage(this.page);
    } catch (e) {
      common.setLoading(false);
      common.setError(e);
    }
  }

  async deleteTrip() {
    try {
      common.setLoading(true);
      await doGet("/api/trip/" + this.trip._id + "/delete");
      this.$emit("reload", true);
      common.showMessage("Trip Deleted");
      common.setLoading(false);
    } catch (e) {
      common.setLoading(false);
      common.setError(e);
    }
  }

  mounted() {
    if (this.value) this.bu = this.value;
  }

  @Watch("selected")
  onSelectedChange(val) {
    this.trip.selected = val;
  }

  @Watch("value")
  onValueChange(val) {
    this.trip = val;
  }
}
</script>


<style scoped>
.tbody {
  height: 30px;
}
.tbody tr td {
  padding: 0 2px !important;
  cursor: pointer;
}

.tbody tr td .v-input--checkbox {
  padding: 0;
  height: 30px;
  margin-top: 8px;
}

.isActive,
.isActive:hover {
  background-color: #b2dfdb !important;
}
</style>